import { Link, useSearchParams } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const [params] = useSearchParams();
  const order = params.get("order");
  return (
    <div className="max-w-xl mx-auto px-4 py-28 text-center" data-testid="payment-cancel-page">
      <XCircle className="w-14 h-14 text-gray-400 mx-auto" strokeWidth={1.4} />
      <h1 className="font-serif text-4xl mt-8 text-charcoal">Payment Cancelled</h1>
      <p className="text-gray-500 mt-3">
        No payment was taken{order ? ` for order ${order}` : ""}. Your bag is still saved — you can complete checkout whenever you're ready.
      </p>
      <div className="flex items-center justify-center gap-3 mt-8">
        <Link to="/checkout" data-testid="payment-retry-checkout"
          className="bg-pink text-white px-9 py-4 text-xs uppercase tracking-[0.18em] hover:bg-pink-hover transition-colors">
          Return to Checkout
        </Link>
        <Link to="/shop/all" className="border border-gray-300 px-9 py-4 text-xs uppercase tracking-[0.18em] hover:border-pink hover:text-pink transition-colors">
          Continue Shopping
        </Link>
      </div>
    </div>
  );
}
